import Portfolio from './portfolio'

const routes = [
  {
    path: "/portfolio",
    component: Portfolio
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/core/routes.js